import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/notifications/:notificationId/mark-as-read`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const markAsRead = {
  post: apiPathFunc(pathBase),
};
